const OPENING_TIMEOUT_IN_MS = 5000;
export const openSignalingChannel = (signalingChannel, logger) => new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
        logger.error('Could not open signaling channel within timeout');
        signalingChannel.close();
        signalingChannel.removeAllListeners();
        reject(new Error(`Could not open signaling channel - Timeout after ${OPENING_TIMEOUT_IN_MS}`));
    }, OPENING_TIMEOUT_IN_MS);
    signalingChannel.on('open', () => {
        logger.debug('Signaling channel opened');
        clearTimeout(timeout);
        signalingChannel.removeAllListeners();
        signalingChannel.on('close', () => {
            logger.debug('Received signaling channel close');
        });
        resolve(signalingChannel);
    });
    signalingChannel.on('close', () => {
        logger.error('Received signaling channel close');
        signalingChannel.removeAllListeners();
        reject(new Error('Could not open signaling channel - Received signaling channel close'));
    });
    signalingChannel.on('error', (error) => {
        logger.error('Failed to open signaling channel', { error });
        signalingChannel.close();
        signalingChannel.removeAllListeners();
        reject(new Error('Could not open signaling channel - Error while opening', { cause: error }));
    });
    signalingChannel.open();
});
//# sourceMappingURL=common.js.map